import { Anchor, Box } from '@mantine/core';
import { IME_APLIKACIJE } from '../ime';
import { Logotip } from '../postavitev/Logotip';
import { Kartica, Podatki } from '../postavitev/Podatki';
import { useSeja } from '../seja/useSeja';
import { GlavaZaslona, ZaslonSeznama } from '../seznam/Seznam';

/** Informacije (vizitka): podatki o programu, naročnik in kontakt za podporo. */
export function Informacije() {
  const stanje = useSeja();
  const narocnik = stanje.status === 'prijavljen' ? stanje.instanca.naziv : '';
  return (
    <ZaslonSeznama>
      <GlavaZaslona naslov="Informacije" opis="Podatki o programu in kontakt za podporo." />
      <Kartica>
        <Box mb="md">
          <Logotip velikost={28} temno />
        </Box>
        <Podatki
          vrstice={[
            ['Ime aplikacije', `${IME_APLIKACIJE} (spletna aplikacija)`],
            ['Naročnik', narocnik ?? ''],
            ['Razvijalec', 'LunaLabs'],
            ['Skrbnik', 'Matjaž Kranjc'],
            [
              'Splošni pogoji',
              <Anchor key="p" href="/splosni-pogoji" target="_blank" rel="noreferrer">
                Splošni pogoji uporabe in varstvo osebnih podatkov
              </Anchor>,
            ],
            [
              'Kontakt',
              <Anchor key="k" href="mailto:podpora@lunalabs.solutions">
                podpora@lunalabs.solutions
              </Anchor>,
            ],
          ]}
        />
      </Kartica>
    </ZaslonSeznama>
  );
}
